var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGstIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.125 13.75C5.74632 13.75 6.25 13.2463 6.25 12.625C6.25 12.0037 5.74632 11.5 5.125 11.5C4.50368 11.5 4 12.0037 4 12.625C4 13.2463 4.50368 13.75 5.125 13.75Z",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 3.25H4.75C3.7558 3.25119 2.80267 3.64666 2.09966 4.34966C1.39666 5.05267 1.00119 6.0058 1 7L1 13C1.00119 13.9942 1.39666 14.9473 2.09966 15.6503C2.80267 16.3533 3.7558 16.7488 4.75 16.75H15.25C16.2442 16.7488 17.1973 16.3533 17.9003 15.6503C18.6033 14.9473 18.9988 13.9942 19 13V7C18.9988 6.0058 18.6033 5.05267 17.9003 4.34966C17.1973 3.64666 16.2442 3.25119 15.25 3.25ZM4.75 4.75H15.25C15.8467 4.75 16.419 4.98705 16.841 5.40901C17.2629 5.83097 17.5 6.40326 17.5 7H2.5C2.5 6.40326 2.73705 5.83097 3.15901 5.40901C3.58097 4.98705 4.15326 4.75 4.75 4.75ZM15.25 15.25H4.75C4.15326 15.25 3.58097 15.0129 3.15901 14.591C2.73705 14.169 2.5 13.5967 2.5 13V8.5H17.5V13C17.5 13.5967 17.2629 14.169 16.841 14.591C16.419 15.0129 15.8467 15.25 15.25 15.25Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGstIcon);
export default __webpack_public_path__ + "static/media/gst-icon.7a5b10f5671b9094330a6b7a6ca420d7.svg";
export { ForwardRef as ReactComponent };